import React from "react";
import { required, TextInput } from "react-admin";

const NamesInput = ({ readOnly }) => {
  return (
    <>
      <TextInput
        label="Име на български език"
        source="nameBg"
        validate={required()}
        readOnly={readOnly}
      />
      <TextInput
        label="Име на английски език"
        source="nameEn"
        validate={required()}
        readOnly={readOnly}
      />
    </>
  );
};

export default NamesInput;
